import React, {Component} from "react";
import RestRequest from "../../../tools/RestRequest";
import config from "../../../config";
import Error from "../html/Error";

class DateDeliveryField extends Component {
    constructor(props) {
        super(props);


        this.state = {
            items: [],
        };

        RestRequest.all(`${config.restDate}`).then(data => {
            this.setState({items: data});
        });
    }

    render() {
        let error, aria_invalid;
        const {items} = this.state;

        if (typeof this.props.errors === 'object' && !Array.isArray(this.props.errors)) {
            error = <Error errors={this.props.errors['time']}/>
            aria_invalid = this.props.errors['time'] !== undefined;
        }


        return (
            <label className="checkout-form__label" htmlFor="checkout-date-delivery">
                <div className="checkout-form__label-text">Дата доставки*</div>
                <div className="form-group field-checkout-date-delivery required">
                    <label className="select" htmlFor="checkout-time-delivery" aria-invalid={aria_invalid}>
                        <select required className="checkout-form__select" name="OrderDate[date]">
                            <option value="" disabled="disabled" selected="selected">День доставки</option>
                            {Object.keys(items).map((element, key) => {
                                return <option key={key} value={element}>{items[element]}</option>;
                            })}
                        </select>

                        <svg>
                            <use xlinkHref="#select-arrow-down"/>
                        </svg>
                    </label>
                    <p className="help-block help-block-error"/>
                </div>
            </label>
        );
    }
}

export default DateDeliveryField;